import { createContext, useEffect, useState } from "react";
import { REACT_APP_API_BASE_URL } from "../constants/apiConstants";

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState();

  const apiBaseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_API_BASE_URL
      : REACT_APP_API_BASE_URL;

  useEffect(() => {
    const token = localStorage.getItem("user_token");
    const userUuid = localStorage.getItem("user_uuid");
    const urlEmbed = localStorage.getItem("url_embed");

    if (token && userUuid) {
      setUser({ uuid: userUuid, urlEmbed: urlEmbed });
    }
  }, []);

  const signin = async (username, password) => {
    try {
      const response = await fetch(`${apiBaseUrl}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: username,
          password: password,
        }),
      });

      if (!response.ok) {
        if (response.status === 401) {
          return "E-mail ou senha incorretos";
        }
        return "Erro ao fazer login";
      }

      const data = await response.json();

      localStorage.setItem("user_token", JSON.stringify(data.access_token));
      localStorage.setItem("user_uuid", data.userUuid);
      localStorage.setItem("url_embed", data.urlEmbed);

      setUser({ uuid: data.userUuid, urlEmbed: data.urlEmbed });

      return;
    } catch (error) {
      console.error("Erro ao fazer login:", error);
      return "Erro na conexão com o servidor";
    }
  };

  const signout = () => {
    setUser(null);
    localStorage.removeItem("user_token");
  };

  return (
    <AuthContext.Provider value={{ user, signed: !!user, signin, signout }}>
      {children}
    </AuthContext.Provider>
  );
};
